import React, {useMemo, useState} from 'react';
import './mainLayout.scss';
import {Dropdown, Layout, Menu, Space} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import './style.css';
import AppInfoView from '../../CommonComponents/AppInfoView/appInfoView';
import InitialFooter from '../../CommonComponents/FooterInc';
import Footer from '../../CommonComponents/CommonFooter';
import {getAllChapters, setChapterById} from '../../../Store/Actions';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';
import {
  createSelectionMenuOptionsUtil,
  createSelectionOptionsUtilForEmailToMembers,
} from '../../../Util/commonUtility';
import ToggleSwitch from '../ToggleSwith';
import {useJWTAuthActions} from '../../../Api/JWTAuthProvider';
const {Header, Content} = Layout;
import ProfileInfo from '../ProfileView';
import arrowDown from './../../../Assets/svgs/arrowDown.svg';
import ProfileInfo2 from '../ProfileView2';
import {
  internationalCompressedFooterLogo,
  internationalCompressed,
} from '../../../Resource/images';

import {applicationConfig} from '../../../Util/config';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';

const MainLayout = (props) => {
  const dispatch = useDispatch();
  const {ApplicationString, currentLanguage, changeLanguage} =
    useLocalization();
  const [searchParams, setSearchParams] = useSearchParams();
  const {allChapters} = useSelector(({chapters}) => chapters);
  const {logout} = useJWTAuthActions();
  const [chapterUrlLogo, setChapterUrlLogo] = useState(internationalCompressed);
  const [japaneseLogoUrl, setJapaneseLogoUrl] = useState(
    internationalCompressed,
  );
  const [chapterUrlLogoDark, setChapterUrlLogoDark] = useState(
    internationalCompressedFooterLogo,
  );
  const [chapterList, setChapterList] = useState([]);
  const [shouldRender, setshouldRender] = useState(false);
  const [dropDownMenu, setDropDownMenu] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(false);
  const [isLogin, setIsLogin] = useState(() => {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  });
  const currentPath = window.location.pathname;
  const splitted = currentPath.split('/');
  const splittedChapter = splitted[splitted?.length - 1];

  useEffect(() => {
    const userInfoStr = localStorage.getItem('userInfo');
    setIsLogin(userInfoStr ? JSON.parse(userInfoStr) : null);
    // The chapter page fetches the chapter list itself; skip only the duplicate
    // request here, the header/footer menus still need the list once it lands.
    const isChapterDetailRoute =
      currentPath.startsWith('/chapter/') && currentPath !== '/chapter/';

    if (allChapters) {
      const visibleChapters = allChapters?.data?.chapters?.filter((chapter) => {
        return chapter?.is_visible_on_map === true;
      });
      setChapterList(
        createSelectionOptionsUtilForEmailToMembers(
          visibleChapters,
          'id',
          'name',
        ),
      );
    } else if (!isChapterDetailRoute) {
      dispatch(getAllChapters(true));
    }
  }, [allChapters, currentPath, dispatch]);

  // Update isLogin when route changes or when user logs in
  useEffect(() => {
    const userInfoStr = localStorage.getItem('userInfo');
    const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
    setIsLogin(userInfo);
  }, [currentPath]);

  let navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState();

  useEffect(() => {
    const isLoginUser = JSON.parse(localStorage.getItem('userInfo'));
    if (isLoginUser?.role === 'admin') {
      setSelectedRole('admin');
    } else if (isLoginUser?.role === 'user') {
      setSelectedRole('user');
    }
  }, []);

  const visibleChapters = useMemo(
    () => chapterList?.filter((chapter) => chapter?.is_visible_on_map === true),
    [chapterList],
  );

  const handleLanguageChange = () => {
    if (
      currentLanguage === LANGUAGES.JA &&
      chapterUrlLogo !== japaneseLogoUrl
    ) {
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      searchParams.delete('language');
    }
  };

  // Handle logo click navigation - respect current language
  const handleLogoClick = () => {
    if (currentLanguage === LANGUAGES.JA) {
      if (currentPath === `/chapter/${japaneseChapterName}`) {
        navigate('/');
        changeLanguage(LANGUAGES.EN);
        localStorage.setItem('pbssLanguage', LANGUAGES.EN);
        searchParams.delete('language');
      } else {
        navigate(`/chapter/${japaneseChapterName}?lang=ja`);
      }
    } else {
      navigate('/');
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      searchParams.delete('language');
    }
  };

  const handleNavbarLinkClick = (path) => {
    navigate(path);
    if (currentLanguage === LANGUAGES.JA) {
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      searchParams.delete('language');
    }
  };
  const japaneseChapterName = visibleChapters?.find(
    (chapter) => chapter?.name === 'Japan',
  )?.normalized_name;

  useEffect(() => {
    if (currentPath !== '/') {
      if (
        visibleChapters?.find((obj) => obj.normalized_name === splittedChapter)
      ) {
        const filteredChapterUrl = visibleChapters?.find(
          (chapter) => chapter?.normalized_name === splittedChapter,
        );
        const logoName = filteredChapterUrl?.logo_ids[0]?.name;
        const logoDarkName = filteredChapterUrl?.dark_logo_ids[0]?.name;
        const logoUrl = `${applicationConfig.UPLOAD_URL}/${logoName}`;
        const logoUrlDark = `${applicationConfig.UPLOAD_URL}/${logoDarkName}`;
        setChapterUrlLogo(logoName ? logoUrl : internationalCompressed);
        setChapterUrlLogoDark(
          logoDarkName ? logoUrlDark : internationalCompressed,
        );
        setJapaneseLogoUrl(logoName ? logoUrl : internationalCompressed);
      } else {
        const currentLanguage = searchParams.get('language');
        if (
          currentLanguage === LANGUAGES.JA &&
          currentPath !== `/chapter/${japaneseChapterName}`
        ) {
          const japaneseChapterDetails = visibleChapters?.find(
            (chapter) => chapter?.name === 'Japan',
          );
          const japaneseLogoName = japaneseChapterDetails?.logo_ids[0]?.name;
          const japaneseLogoDarkName =
            japaneseChapterDetails?.dark_logo_ids[0]?.name;
          const japaneseLogoUrl = `${applicationConfig.UPLOAD_URL}/${japaneseLogoName}`;
          const japaneseLogoUrlDark = `${applicationConfig.UPLOAD_URL}/${japaneseLogoDarkName}`;
          setChapterUrlLogo(
            japaneseLogoName ? japaneseLogoUrl : internationalCompressed,
          );
          setChapterUrlLogoDark(
            japaneseLogoDarkName
              ? japaneseLogoUrlDark
              : internationalCompressedFooterLogo,
          );
          setJapaneseLogoUrl(
            japaneseLogoName ? japaneseLogoUrl : internationalCompressed,
          );
        } else {
          setChapterUrlLogo(internationalCompressed);
          setChapterUrlLogoDark(internationalCompressedFooterLogo);
        }
      }
    } else {
      setChapterUrlLogo(internationalCompressed);
      setChapterUrlLogoDark(internationalCompressedFooterLogo);
    }
  }, [searchParams, visibleChapters, currentPath]);

  const logoLink = (() => {
    if (currentLanguage === LANGUAGES.JA) {
      if (currentPath === `/chapter/${japaneseChapterName}`) {
        return '/';
      } else {
        return `/chapter/${japaneseChapterName}`;
      }
    } else {
      return '/';
    }
  })();

  const renderIcon = (layoutWidth, screenSize) => {
    return layoutWidth < screenSize ? null : (
      <img src={arrowDown} width={30} height={30} />
    );
  };

  const navBarItems = [
    {
      id: 'header-mainPage-9',
      label: ApplicationString['mainLayoutComponent.navbar.mainPage'],
      key: ' ',
    },
    {
      id: 'header-aboutpbss-1',
      label: ApplicationString['mainLayoutComponent.navbar.aboutPbss'],
      key: 'aboutUs',
    },
    {
      id: 'header-events-2',
      label: ApplicationString['mainLayoutComponent.navbar.events'],
      key: 'events',
      icon: <img src={arrowDown} width={30} height={30} />,
      children: [
        {
          label: ApplicationString['mainLayoutComponent.navbar.pickALocation'],
          key: 'PickLocation',
          children: [
            ...createSelectionMenuOptionsUtil(
              visibleChapters,
              'normalized_name',
              'name',
            ),
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.pbssInternational'
                ],
              key: '',
            },
          ],
          onClick: () => {
            handleLanguageChange();
          },
        },
        {
          label: ApplicationString['mainLayoutComponent.navbar.eventTypesInfo'],
          key: 'EventTypes',
          children: [
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.seminarLuncheons'
                ],
              key: 'eventType/seminarLuncheons',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.workshops'
                ],
              key: 'eventType/workshops',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.symposia'
                ],
              key: 'eventType/symposia',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.webinars'
                ],
              key: 'eventType/webinars',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.dinnerSeminars'
                ],
              key: 'eventType/dinnerSeminars',
            },
          ],
        },
      ],
    },
    {
      id: 'header-sponsorships-2',
      label: ApplicationString['mainLayoutComponent.navbar.sponsorships'],
      key: 'sponsorshipInfo',
    },
    {
      id: 'header-jobs-4',
      label: ApplicationString['mainLayoutComponent.navbar.jobPostings'],
      key: 'jobs/approved',
    },
    {
      id: 'header-resources-5',
      label: ApplicationString['mainLayoutComponent.navbar.resources'],
      key: 'resources',
      icon: renderIcon(layoutWidth, 1254),
      children: [
        {
          label:
            ApplicationString[
              'mainLayoutComponent.navbar.resources.stemOutreach'
            ],
          key: 'stemOutreach',
        },
        {
          label:
            ApplicationString[
              'mainLayoutComponent.navbar.resources.industryOutreach'
            ],
          key: 'industryOutreach',
        },
        {
          label:
            ApplicationString[
              'mainLayoutComponent.navbar.resources.careerMentorship'
            ],
          key: 'careerMentorship',
        },
        {
          label:
            ApplicationString['mainLayoutComponent.navbar.resources.partners'],
          key: 'Partners',
        },
      ],
    },
    {
      id: 'header-contactus-6',
      label: ApplicationString['mainLayoutComponent.navbar.contactUs'],
      key: 'contactUs',
    },
    {
      id: 'header-faq-7',
      label: ApplicationString['mainLayoutComponent.navbar.faq'],
      key: 'faq',
    },
  ];

  const currActivePath = (items) => {
    if (currentPath.includes('chapter')) {
      const eventChilds = items.find((item) => item.key === 'events');
      return eventChilds.children[0]?.children.find(
        (item) => currentPath === `/${item.key}`,
      )?.key;
    } else if (currentPath === '/eventVendorShow') {
      return 'eventVendorShow';
    } else if (currentPath === '/eventMajorSponsor') {
      return 'eventMajorSponsor';
    } else if (currentPath === '/sponsorshipInfo/SF-Bay') {
      return 'sponsorshipInfo/SF-Bay';
    } else if (currentPath === '/sponsorshipInfo/Boston') {
      return 'sponsorshipInfo/Boston';
    } else if (currentPath === '/sponsorshipInfo/San-Diego') {
      return 'sponsorshipInfo/San-Diego';
    } else if (currentPath === '/sponsorshipInfo/Vancouver') {
      return 'sponsorshipInfo/Vancouver';
    } else if (currentPath === '/sponsorshipInfo/Korea') {
      return 'sponsorshipInfo/Korea';
    } else if (currentPath === '/eventType/seminarLuncheons') {
      return 'eventType/seminarLuncheons';
    } else if (currentPath === '/eventType/workshops') {
      return 'eventType/workshops';
    } else if (currentPath === '/eventType/symposia') {
      return 'eventType/symposia';
    } else if (currentPath === '/eventType/dinnerSeminars') {
      return 'eventType/dinnerSeminars';
    } else if (currentPath === '/eventType/webinars') {
      return 'eventType/webinars';
    } else if (currentPath === '/') {
      return ' ';
    } else {
      return items.find((item) => currentPath.includes(item.key))?.key;
    }
  };

  const handleLogoutClick = () => {
    logout();
  };
  useEffect(() => {
    const handleWindowResize = () => {
      setLayoutWidth(window.outerWidth);
      if (window.outerWidth < 900) {
        setshouldRender(true);
      } else {
        setshouldRender(false);
      }
      if (window.outerWidth < 1620) {
        setDropDownMenu(true);
      } else {
        setDropDownMenu(false);
      }
    };
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const dropDownProfile = (
    <Menu>
      <ProfileInfo logout={handleLogoutClick} />
    </Menu>
  );
  return (
    <Layout style={{background: 'none'}} className='layout'>
      <div className='nav-header-sticky'>
        <div className='nav-header-container'>
          <div className='nav-haeder-wapper'>
            {shouldRender ? (
              <Header className='pbss-in-header' prefixCls='nav-bar'>
                <Link
                  to={logoLink}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogoClick();
                  }}>
                  <img
                    className={'header-chapter-logo'}
                    crossOrigin='anonymous'
                    src={chapterUrlLogo}
                    alt='logo'
                    id='header-logo-home-1'
                  />
                </Link>
                <div className='button-container-header'>
                  <ToggleSwitch
                    chapterLogo={chapterUrlLogo}
                    chapterList={visibleChapters}
                    logout={handleLogoutClick}
                    profileView={<ProfileInfo2 />}
                  />
                </div>
              </Header>
            ) : (
              <Header className='pbss-in-header' prefixCls='nav-bar'>
                <Link
                  to={logoLink}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogoClick();
                  }}>
                  <img
                    className={'header-chapter-logo'}
                    src={chapterUrlLogo}
                    crossOrigin='anonymous'
                    alt='logo'
                    id='header-logo-home-2'
                  />
                </Link>
                <Menu
                  id={navBarItems.id}
                  // onClick={onMenuItemClick}
                  prefixCls='pbss-hader-menu'
                  popupOffset={[0, 10]}
                  theme='light'
                  mode='horizontal'
                  selectedKeys={currActivePath(navBarItems)}
                  // items={navBarItems}
                >
                  {navBarItems.map((item) =>
                    item.children ? (
                      <Menu.SubMenu
                        key={item.key}
                        icon={item.icon}
                        title={item.label}>
                        {item.children.map((child) =>
                          child.children ? (
                            <Menu.SubMenu key={child.key} title={child.label}>
                              {child.children.map((subChild) => (
                                <Menu.Item
                                  key={subChild.key}
                                  icon={subChild.icon}>
                                  <Link
                                    to={`/${subChild.key}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleNavbarLinkClick(`/${subChild.key}`);
                                      if (child.onClick) {
                                        child.onClick();
                                      }
                                    }}>
                                    {subChild.label}
                                  </Link>
                                </Menu.Item>
                              ))}
                            </Menu.SubMenu>
                          ) : (
                            <Menu.Item key={child.key} icon={child.icon}>
                              <Link
                                to={`/${child.key}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleNavbarLinkClick(`/${child.key}`);
                                }}>
                                {child.label}
                              </Link>
                            </Menu.Item>
                          ),
                        )}
                      </Menu.SubMenu>
                    ) : (
                      <Menu.Item key={item.key} icon={item.icon}>
                        <Link
                          to={`/${item.key}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavbarLinkClick(`/${item.key}`);
                          }}>
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ),
                  )}
                </Menu>

                <div className='button-container-header'>
                  {isLogin ? (
                    ''
                  ) : (
                    <>
                      {currentPath === '/register' ? (
                        ''
                      ) : (
                        <button
                          onClick={() => {
                            navigate('/register');
                          }}
                          id='join'
                          className='common-button-header bg-remove extend-button-w extend-settings-button join-button'>
                          {ApplicationString['mainLayoutComponent.navbar.join']}
                        </button>
                      )}
                      {currentPath === '/login' ? (
                        ''
                      ) : (
                        <button
                          onClick={() => {
                            navigate('/login');
                          }}
                          id='login'
                          className='common-button-header extend-settings-button'>
                          {
                            ApplicationString[
                              'mainLayoutComponent.navbar.login'
                            ]
                          }
                        </button>
                      )}
                    </>
                  )}
                  {/* <Select
                      id='chapter-select'
                      prefixCls='chapter'
                      showSearch
                      optionFilterProp='children'
                     filterOption={(input, option) =>
                    option?.label.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                      placeholder={'Select Chapters'}
                      onChange={handleChapterChange}
                      defaultValue={defaultChapterValue}
                      value={
                        defaultChapterValue
                          ? defaultChapterValue
                          : 'Select Chapter'
                      }
                      options={chapterList}
                      suffixIcon={<CaretDownOutlined />}
                      className='chapter-select'></Select> */}
                  {isLogin ? (
                    <Space>
                      <Dropdown
                        className='custom-profile-button'
                        prefixCls='custom-dropdown-button'
                        overlay={dropDownProfile}
                        placement='bottomRight'
                        trigger={['click']}>
                        <button
                          id='header-dropdown-profile'
                          className='user-profile-button-menu'
                          style={{cursor: 'pointer'}}>
                          <UserOutlined />
                          {
                            ApplicationString[
                              'profileViewComponent.button.myAccount'
                            ]
                          }
                          <img src={arrowDown} alt='Dropdown Arrow' />
                        </button>
                      </Dropdown>
                    </Space>
                  ) : (
                    ''
                  )}
                </div>
                {/* )} */}
              </Header>
            )}
          </div>
        </div>
      </div>
      <AppInfoView />
      <Content className='site-layout-content main-layout-container'>
        <div className='site-layout-content-box'>{props.children}</div>
      </Content>
      <div className='footer-main-container-wrapper'>
        <div className='footer-main-container intial-footer-background'>
          <div className='wapper-main-footer'>
            <InitialFooter
              chapterList={chapterList}
              chapterLogo={chapterUrlLogoDark}
            />
          </div>
        </div>
        <div className='footer-main-container sm-footer-background'>
          <div className='wapper-main-footer'>
            <Footer />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MainLayout;
